import { Repository } from 'rest-adapter';
import { Config } from '../Config';
import { Groups, TypeInterface } from '../Enum/Groups';
import { ServiceLocator } from '../ServiceLocator';

export class TypeUtility<T> {
    public static getResourceTypeForType(type: TypeInterface, config: Config) {
        return `${config.language}-products/` + type.replace('.', '-');
    }

    constructor(private readonly serviceLocator: ServiceLocator) {
    }

    public getRepositoryForGroups(group: Groups): Repository<T> {
        switch (group) {
            case Groups.SteeringFrame :
                return this.serviceLocator.get('steeringFrameRepository');
            case Groups.LinearActuator :
                return this.serviceLocator.get('linearActuatorRepository');
            case Groups.WebGuideController :
                return this.serviceLocator.get('webGuideControllerRepository');
            case Groups.TensionController :
                return this.serviceLocator.get('tensionControllerRepository');
            case Groups.ForceSensor :
                return this.serviceLocator.get('forceSensorRepository');
            case Groups.Amplifier :
                return this.serviceLocator.get('amplifierRepository');
            case Groups.MaterialSensor :
                return this.serviceLocator.get('materialSensorRepository');
            case Groups.TensionAccessories :
                return this.serviceLocator.get('tensionAccessoriesRepository');
            case Groups.WebGuideAccessories :
                return this.serviceLocator.get('webGuideAccessoriesRepository');
            case Groups.TelemetrySystem :
                return this.serviceLocator.get('telemetrySystemRepository');
            case Groups.MeasuringRoller:
                return this.serviceLocator.get('measuringRollerRepository');
            case Groups.Electronics:
                return this.serviceLocator.get('electronicsRepository');
        }
    }
}
